import { autoinject, bindable } from 'aurelia-framework';
import { LinkedMappingsService, RequiredDimensionValue, CostCenterConditionTargetingModel, CostCenterServiceLink } from "./linked-mappings-service";
import { last, every } from "lodash";
import { ApiService } from '../../../utils/api-service';
import { ResponseHandler } from '../../../utils/response-handler';
import { IDimension } from './service-targeting';

@autoinject
export class CostCenterConditionEdit {
	@bindable costCenterId: string;
	@bindable fiscalYearId: string;
	@bindable serviceStructureId: string;
	@bindable showTargetingEditForm: boolean;
	@bindable dimensions: IDimension[];

	requiredDimensionValues: RequiredDimensionValue[];
	areRequiredDimensionValuesValid: boolean = true;
	validationErrors: string[];

	dimensionsForCondition(index: number): IDimension[] {
		return index === 0 ?
			this.dimensions :
			this.dimensions.filter(dimension => {
				return !this.requiredDimensionValues.some(v => v.dimensionId === dimension.id);
			});
	}

	constructor(private linkedMappingsService: LinkedMappingsService, private http: ApiService, private responseHandler: ResponseHandler) {
		this.requiredDimensionValues = [];
		this.validationErrors = [];
	}

	// Ensure that conditions have both dimensionId and dimensionValueId is set
	allConditionsValid(): boolean {
		const nonEmptyDims = this.requiredDimensionValues.filter(o => o.dimensionId);
		this.areRequiredDimensionValuesValid =
			nonEmptyDims.length && every(nonEmptyDims, o => o.validateForInsert);
		return this.areRequiredDimensionValuesValid;
	}

	handleErrorResponse(validationErrors: { [key: string]: string; }) {
		for(let i in validationErrors) {
			if (validationErrors.hasOwnProperty(i)) {
				this.validationErrors.push(validationErrors[i]);
			}
		}
	}

	insertCostCenterCondition() {
		this.validationErrors.splice(0);
		if(this.allConditionsValid()) {
			this.linkedMappingsService.insertCostCenterCondition(this.fiscalYearId, this.serviceStructureId, this.costCenterId, this.requiredDimensionValues.filter((item) => item.dimensionValueId && item.dimensionId))
				.then(async response => {
					if (this.responseHandler.isSuccess(response.status)) {
						await this.linkedMappingsService.refreshCostCenterConditionsCache(this.fiscalYearId, this.serviceStructureId);

						const newId = (await response.json()).id;
						const newModel = this.linkedMappingsService.costCenterConditionsCache.find(ccc => ccc.id == newId);
						if (newModel) { newModel.isCollapsed = false; }

						this.showTargetingEditForm = false;
					} else {
						response.json().then(this.handleErrorResponse.bind(this));
					}
				});
		}
	}

	attached() {
		this.requiredDimensionValues.push(new RequiredDimensionValue());
	}

	detached() {
		this.requiredDimensionValues.length = 0;
	}
}
